export function isPlatformIOS() 
{
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
}

export function isPlatformAndroid()
{
  let platform = (''+navigator.platform).toLowerCase();
  return platform.includes('android');
}

export function hasVirtualKeyboard()
{
  return isPlatformAndroid() || isPlatformIOS();
}

export function autocompleteMenuProps() 
{
    // default properties copied from the vuetify-autocomplete docs
    let defaultProps = {
        closeOnClick: false,
        closeOnContentClick: false,
        disableKeys: true,
        openOnClick: false,
        maxHeight: 304,
    };

    if ( isPlatformIOS() )
    {
        defaultProps.maxHeight = 105;
    }

    return defaultProps;
}

  export default { 
    isPlatformIOS,
    isPlatformAndroid,
    autocompleteMenuProps,
    hasVirtualKeyboard,
  };